import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import ParishGroups from './Groups'
import ParishTeam from './Team'
import ParishDonationFields from './DonationFields'
import ParishGivingSettings from './GivingSettings'

// Groups, Team and Donation Fields are all "configuration" for a parish, so
// they live together under one Settings tab instead of each taking a
// top-level nav slot. Each pane below is the same page component that used
// to live at its own route (/app/parish/groups, /team, /donation-fields) —
// unchanged, just re-hosted here. Their old routes now just redirect here
// (see App.js) so bookmarks and in-app links keep working.
const SECTIONS = [
  { key: 'groups', label: 'Groups', Component: ParishGroups },
  { key: 'team', label: 'Team', Component: ParishTeam },
  { key: 'donation-fields', label: 'Donation Fields', Component: ParishDonationFields },
  { key: 'giving', label: 'Giving', Component: ParishGivingSettings },
]

export default function ParishSettings() {
  const { section: rawSection } = useParams()
  const navigate = useNavigate()

  const isKnownSection = SECTIONS.some((s) => s.key === rawSection)
  const activeKey = isKnownSection ? rawSection : 'groups'
  const active = SECTIONS.find((s) => s.key === activeKey)
  const ActivePane = active.Component

  return (
    <div>
      {/* Each pane below (Groups/Team/DonationFields) renders its own <h1>
          heading unchanged, so this container intentionally has no "Settings"
          heading of its own — that would duplicate the pane's heading right
          above it. The tabs alone make it clear this is the Settings area. */}
      <div className="mb-6 border-b border-surface-border flex gap-4">
        {SECTIONS.map((s) => (
          <button
            key={s.key}
            type="button"
            onClick={() => navigate(`/app/parish/settings/${s.key}`)}
            className={`px-3 py-2 text-sm font-medium transition-colors duration-150 border-b-2 -mb-px ${
              s.key === activeKey
                ? 'text-gold border-gold'
                : 'text-charcoal-muted border-transparent hover:text-charcoal'
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <ActivePane />
    </div>
  )
}
